import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { SIGNATURE_CANVAS_HEIGHT, SIGNATURE_INK_COLOR } from './constants';

export const DrawSignature = ({ onCanvasRef, onDrawingChange }) => {
    const wrapperRef = useRef(null);
    const canvasRef = useRef(null);
    const [width, setWidth] = useState(0);
    const [hasDrawing, setHasDrawing] = useState(false);

    useLayoutEffect(() => {
        const measure = () => {
            if (wrapperRef.current) {
                setWidth(wrapperRef.current.offsetWidth);
            }
        };
        measure();
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, []);

    useEffect(() => {
        onCanvasRef?.(canvasRef);
        setHasDrawing(false);
        onDrawingChange?.(false);
    }, [width]);

    const handleBegin = () => {
        setHasDrawing(true);
        onDrawingChange?.(true);
    };

    const clearSignature = () => {
        canvasRef.current?.clear();
        setHasDrawing(false);
        onDrawingChange?.(false);
    };

    return (
        <>
            <div className="signature-request-canvas-box" ref={wrapperRef}>
                {!!width && (
                    <SignatureCanvas
                        key={width}
                        ref={canvasRef}
                        penColor={SIGNATURE_INK_COLOR}
                        canvasProps={{ width, height: SIGNATURE_CANVAS_HEIGHT, className: 'signature-request-canvas' }}
                        onBegin={handleBegin}
                    />
                )}
                {!hasDrawing && <p className="signature-request-canvas-placeholder">Click to draw your signature</p>}
                <div className="signature-request-canvas-line" />
            </div>

            <div className="signature-request-draw-actions">
                <button type="button" className="signature-request-clear-btn" disabled={!hasDrawing} onClick={clearSignature}>
                    Clear
                </button>
            </div>
        </>
    );
};
